import React from 'react';
import { SunlightFlow, Pic } from './Landing';

// Visuals page (added 24 Oct 2026). Route: /visuals. Holds the concept panels moved off the home page.
const panels = [
  { src: '/images/02-hero-photo-solar-canopy.jpg', w: 1584, h: 672, title: 'Solar canopy over crops', desc: 'Perovskite PV canopy with LED bars beneath and the city beyond.' },
  { src: '/images/02b-hero-photo-solar-canopy-alt.jpg', w: 1584, h: 672, title: 'Solar canopy, second view', desc: 'Alternative framing of the canopy and crops.' },
  { src: '/images/06-panel-adaptive-led-lighting.jpg', w: 1376, h: 768, title: 'Adaptive LED lighting', desc: 'Intensity follows the growth stage of the crop.' },
  { src: '/images/07-panel-vertical-stacking.jpg', w: 1376, h: 768, title: 'Vertical stacking', desc: 'More growing area on the same footprint.' },
  { src: '/images/08-panel-solar-integrated-building.jpg', w: 1376, h: 768, title: 'Solar-integrated building and daylight', desc: 'Diffuse daylight through PV glazing, with supplemental LED light on the lower tiers.' },
  { src: '/images/09-panel-solar-powered-farming.jpg', w: 1376, h: 768, title: 'Solar-powered farming', desc: 'Clean energy for continuous growth.' },
  { src: '/images/11-detail-light-intensity-widget.png', w: 186, h: 134, title: 'Light intensity control', desc: 'Dashboard widget.' },
  { src: '/images/13-detail-controller-box.png', w: 124, h: 134, title: 'Controller box', desc: 'Site-level LED and PV controller.' },
];

export default function Visuals() {
  console.log('[Visuals] render, panels:', panels.length);
  return (
    <div className="landing-root visuals-root">
      <header className="visuals-header">
        <a href="/" className="visuals-back">&larr; AgriVoLED home</a>
        <h1>Visual Library</h1>
        <p>Concept panels for the AgriVoLED system. Each image is shown at its native size so nothing is stretched.</p>
      </header>
      <section className="section section-sunflow" id="flow">
        <div className="section-header">
          <h2 className="section-title gradient-text-warm">Sunlight, Used Two Ways</h2>
          <p className="section-sub">The sun grows the crop directly where it can, and powers the LEDs where it cannot. Perovskite PV feeds a DC LED drive so only the wavelengths the plant uses are emitted.</p>
        </div>
        <SunlightFlow />
      </section>
      <main className="visuals-grid">
        {panels.map((p, i) => (
          <figure key={i} className={`visuals-card ${p.w > 1000 ? 'visuals-card--wide' : ''}`}>
            <Pic src={p.src} width={p.w} height={p.h} alt={p.title} sizes="(max-width: 760px) 100vw, 760px"/>
            <figcaption>
              <strong>{p.title}</strong>
              <span>{p.desc}</span>
              <small>{p.w} &times; {p.h} px</small>
            </figcaption>
          </figure>
        ))}
      </main>
      <footer className="landing-footer">
        <div className="footer-spectrum"/>
        <div className="footer-inner">
          <span className="footer-name">Agri<span>VoLED</span></span>
          <a href="/" className="visuals-back">Back to home</a>
        </div>
      </footer>
    </div>
  );
}
